// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__khvVR","content":"Tooltip_content__254fa","fade":"Tooltip_fade__3ZTuK"};